module.exports = __webpack_public_path__ + "static/media/ImagePlaceholder.7e4e2bbb.svg";